// removed by extract-text-webpack-plugin
module.exports = {"container":"UserProfileButton-container","menuIcon":"UserProfileButton-menuIcon","icon":"UserProfileButton-icon","menuOverride":"UserProfileButton-menuOverride"};